import { Observable } from 'rxjs';
import { LoginGuestResponse } from '../models/loginGuest-response.model';
import { LoginGuestRequest } from '../models/loginGuest-request.model';
import { UserResponse } from '../models/user-response.model';
import { LoginUserRequest } from '../models/loginUser-request.model';
import { LoginUserResponse } from '../models/loginUser-response.model';

export abstract class UserRepository {
    abstract loginGuest(
        request: LoginGuestRequest,
    ): Observable<LoginGuestResponse>;
    abstract loginUser(
        request: LoginUserRequest,
    ): Observable<LoginUserResponse>;
    abstract getUser(): Observable<UserResponse>;
}
